import { createContext, useContext } from "react";

/**
 * True when rendered inside TableContainer filter UI (dropdown, modal, or inline).
 * AsyncPaginatedSelect uses this to tighten the control layout and to cap menu height
 * so the option list scrolls inside the menu instead of stretching the filter panel.
 * The menu is portaled to `document.body` with a high z-index so it is not clipped by
 * the filter dropdown’s overflow.
 */
export const InsideTableFilterOverlayContext = createContext(false);

export function useInsideTableFilterOverlay(): boolean {
  return useContext(InsideTableFilterOverlayContext);
}
